import * as Yup from "yup";
import "yup-phone";
import { format, getYear } from "date-fns";
import { fDateTime } from "./minimal/formatTime";
import { matchIsValidTel } from "mui-tel-input"

// Yup is throwing n error when validation failed... this is why the try catch blocks

export const isValidEmail = (email) => {
    try {
        email = email ? email.trim().toLowerCase() : ''
        if (!email) {
            return false
        }
        const emailSchema = Yup.string().email();
        emailSchema.validateSync(email)
        return true
    } catch (e) {
        return false
    }
}

export const isValidPhone = (phone) => {
    try {
        return matchIsValidTel(phone)
    } catch (e) {
        return false
    }
}

export const isSafeHttpUrl = (value) => {
    if (!value || typeof value !== 'string') return false
    const normalized = value.trim()
    if (!normalized) return false
    // Reject XSS-prone schemes outright (javascript:, data:, vbscript:, file:).
    if (/^(javascript|data|vbscript|file):/i.test(normalized)) return false
    try {
        const parsed = new URL(normalized)
        return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
        // Not an absolute URL — accept root-relative paths only ('/foo'), so
        // bundler-resolved assets (e.g. import 'foo.pdf') keep working. Reject
        // protocol-relative ('//host/...') and bare relative paths.
        return normalized.startsWith('/') && !normalized.startsWith('//')
    }
}

export const isValidSocialLink = (link, allowedNetworks = null) => {
    // More complex validation can comes here
    link = link ? link.trim().toLowerCase() : ''
    if (!link) {
        return false
    }

    // If allowedNetworks is provided, validate against specific networks
    if (allowedNetworks && allowedNetworks.length > 0) {
        return allowedNetworks.some(network => link.includes(network.toLowerCase()))
    }

    // Fallback to original validation (Facebook and Instagram)
    const isFacebook = link.toLowerCase().includes('facebook')
    const isInstagram = link.toLowerCase().includes('instagram')
    return (isFacebook || isInstagram)
}

export const isValidBirthDate = (date, minAgeAllow) => {
    try {
        const d = new Date(date)
        const yearChars = String(d.getFullYear()).length
        return yearChars === 4
    } catch (e) {
        return false
    }
}

// Handler must be in english and contain no '/' to not break the url.
export const validateHandler = (handler) => {
    const pattern = /^[A-Za-z0-9-_]+$/
    return pattern.test(handler)
}

export const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
}
